(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1159,7113,9134,2721,2179,7446],{

/***/ 9361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 1373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createLucideIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/shared/src/utils.js
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/Icon.js
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const Icon = (0,react.forwardRef)(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => {
    return (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: mergeClasses("lucide", className),
        ...rest
      },
      [
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    );
  }
);


//# sourceMappingURL=Icon.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ className, ...props }, ref) => (0,react.createElement)(Icon, {
      ref,
      iconNode,
      className: mergeClasses(`lucide-${toKebabCase(iconName)}`, className),
      ...props
    })
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map


/***/ }),

/***/ 3642:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/capabilities",
      function () {
        return __webpack_require__(7554);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useScreenSize = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), screenSize = ref[0], setScreenSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function() {
            var screenWidth = window.innerWidth;
            var size = "";
            if (screenWidth < 480) {
                size = "sm";
            } else if (screenWidth >= 440 && screenWidth < 768) {
                size = "md";
            } else if (screenWidth >= 768 && screenWidth < 992) {
                size = "lg";
            } else {
                size = "xl";
            }
            setScreenSize(size);
        };
        handleResize(); // Initial call to set screen size on component mount
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty dependency array to run the effect only once on component mount
    return screenSize;
};
/* harmony default export */ __webpack_exports__["Z"] = (useScreenSize);


/***/ }),

/***/ 1210:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 8418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(5753)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _router = __webpack_require__(6273);
var _addLocale = __webpack_require__(2725);
var _routerContext = __webpack_require__(3462);
var _appRouterContext = __webpack_require__(1018);
var _useIntersection = __webpack_require__(7190);
var _getDomainLocale = __webpack_require__(1210);
var _addBasePath = __webpack_require__(8684);
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, startTransition) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an AppRouterInstance, then it'll have `softPush` and
        // `softReplace`.
        if ("softPush" in router && "softReplace" in router) {
            // If we're doing a soft navigation, use the soft variants of
            // replace/push.
            var method = soft ? replace ? "softReplace" : "softPush" : replace ? "replace" : "push";
            router[method](href);
        } else {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        }
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, soft = props.soft, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "soft",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _slicedToArray(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, appRouter ? startTransition : undefined);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 7190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
var observers = new Map();
var idList = [];
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 1018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 7554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ capabilities; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./utils/capability.json
var capability_namespaceObject = JSON.parse('[{"title":"Strategy","slug":"strategy","link":"/services/strategy","image":"/services/capability/strategy_1.webp","desc":"In the rapidly evolving business landscape, where a staggering increase in global disruption was noted from 2017 to 2022, traditional strategies have a very short shelf life. With only a few of the CEOs feeling confident about their current strategies in today\'s competitive environment, it\'s clear that optimal tactics are not just beneficial but necessary.","category":"Design","meta title":"Business Strategy Consulting Services & Digital Innovation | ITMTB","meta desc":"ITMTB helps businesses align strategy with execution, unlock digital growth, and drive transformation through data-led, agile consulting services."},{"title":"Technology Consulting","slug":"technology-consulting","link":"/services/technology-consulting","image":"/services/capability/tech consulting.webp","desc":"The right technical leadership is at hand with our technology consulting. Our experienced technology leaders can work with your IT teams and drive your important technology decisions, design technology roadmaps best suited for the future of your business.","category":"Design","meta title":"Technology Consulting Services for Scalable Digital Transformation | ITMTB","meta desc":"ITMTB helps organizations define, architect, and scale digital strategies—bridging business goals with future-ready technology solutions."},{"title":"Custom Software Development","slug":"custom-software-development","link":"/services/custom-software-development","image":"/services/capability/automate.webp","desc":"We design and build custom software for organisations that need systems they can depend on for years — greenfield platforms, customer-facing and operational applications, and AI-enabled products. From the first architecture decision through production deployment and sustained operation, we own the engineering lifecycle with you, with QA, observability, and handover built in.","category":"Build","meta title":"Custom Software Development & Enterprise Engineering | ITMTB","meta desc":"ITMTB builds custom software for enterprises — greenfield platforms, web and mobile apps, and AI-enabled systems — engineered for lifecycle ownership, not just delivery."},{"title":"Cloud","slug":"cloud","link":"/services/cloud","image":"/services/capability/cloud.webp","desc":"Benefit your business with industry standard practices. Moving your business to the cloud can help you derive more value from your IT investments. And if you are already on the cloud, having industry experts manage your cloud can save you costs.","category":"Build","meta title":"Cloud Consulting Services & Scalable Cloud Solutions | ITMTB","meta desc":"ITMTB helps enterprises unlock agility, scalability, and resilience through secure cloud platforms, modernization, and custom cloud-native solutions."},{"title":"Cyber Security","slug":"cybersecurity","link":"/services/cybersecurity","image":"/services/capability/security-main.webp","desc":"In an era marked by digital transformation, the acceleration of technology innovation has significantly increased the potential for cyber vulnerabilities. Many CEOs identify the rapid pace of technological advancement as the primary risk factor for cyberattacks. ","category":"Protect","meta title":"Cybersecurity Consulting Services & Threat Protection Solutions | ITMTB","meta desc":"ITMTB helps organizations strengthen cyber defense, ensure compliance, and build secure digital systems with end-to-end cybersecurity solutions."},{"title":"Data and Artificial Intelligence","slug":"analytics-ai-automation","link":"/services/analytics-ai-automation","image":"/services/capability/data.webp","desc":"Artificial Intelligence is for everybody. That is why an increasing number of small and medium businesses have been turning to AI to solve their business problems and make their operations efficient. We believe that the greatest barrier in adopting AI is to understand its suitability to your business problem.","category":"Build","meta title":"Analytics, AI & Automation Consulting Services | ITMTB","meta desc":"ITMTB helps businesses harness data, deploy AI, and automate operations to boost efficiency, unlock insights, and accelerate decision-making."},{"title":"Enterprise Applications and Automation","slug":"cloud","link":"/services/enterprise-applications","image":"/services/capability/automate.webp","desc":"Benefit your business with industry standard practices. Moving your business to the cloud can help you derive more value from your IT investments. And if you are already on the cloud, having industry experts manage your cloud can save you costs.","category":"Build","meta title":"Enterprise Application Consulting & Modernization Services | ITMTB","meta desc":"ITMTB helps modernize enterprise apps to boost agility, scalability, and performance—enabling seamless business operations across platforms."},{"title":"IoT and Digital Engineering","slug":"iot-and-digital-eng","link":"/services/iot-and-digital-eng","image":"/services/capability/iot.webp","desc":"We use the combined power of data and technology to digitize your business every step of the way and reimagine how your products and services work. With technologies such as AR/VR, cloud, AI, 5G, we bring greater productivity and sustainability into your operations.","category":"Build","meta title":"IoT & Digital Engineering Services for Smart Product Innovation | ITMTB","meta desc":"ITMTB enables smart, connected product development with IoT, cloud, and edge solutions—driving speed, scalability, and digital innovation."},{"title":"Managed Services","slug":"managed-services","link":"/services/managed-services","image":"/services/capability/managed-services.webp","desc":" Managed Services have shifted from optional to crucial in today\'s market, significantly boosting financial performance with companies seeing upto 1.8x increase in operating margins. ","category":"Improve","meta title":"Managed IT Services & Scalable Operations Support | ITMTB","meta desc":"ITMTB delivers reliable managed services to help businesses scale, reduce downtime, and streamline IT operations with expert support and automation."},{"title":"Quality Engineering","slug":"quality-engineering","link":"/services/quality-engineering","image":"/services/capability/quality.webp","desc":"Mature Quality Assurance - QA - increases your business uptime, reduces incidents, and drives customer confidence. Mature Quality Assurance - QA - increases your business uptime, reduces incidents, and drives customer confidence. With our mature QA services, we can help you bring reliability into your software systems and get faster release times, operational efficiencies and faster time to market with minimal production defects.","category":"Improve","meta title":"Quality Engineering Services & Automation Testing Solutions | ITMTB","meta desc":"ITMTB helps businesses ensure speed, stability, and coverage with end-to-end quality engineering, test automation, and performance assurance."},{"title":"Startup Solutions","slug":"startup","link":"/startup","image":"/services/capability/startup.webp","desc":"Ignite your startup with custom software, relentless support, and a clear path to scale. We empower founders with rapid MVP development, strategic mentorship, and growth-ready architecture—faster than you imagine.","category":"Build","meta title":"","meta desc":""},{"title":"Agentic Solution","slug":"agentic-ai","link":"/agentic-ai","image":"/services/capability/data.webp","desc":"Artificial Intelligence is for everybody. That is why an increasing number of small and medium businesses have been turning to AI to solve their business problems and make their operations efficient.","category":"Build","meta title":"","meta desc":""},{"title":"AI Strategy For Business","slug":"ai-strategy-for-business","link":"/outcomes","image":"/blogImages/hero/stra-outcome.jpg","desc":"AI That Delivers Strategic Outcomes.","category":"Design","meta title":"Enterprise Application Consulting & Modernization Services | ITMTB","meta desc":"ITMTB helps modernize enterprise apps to boost agility, scalability, and performance—enabling seamless business operations across platforms."}]');
// EXTERNAL MODULE: ./components/reusable/CarouselContainer.js
var CarouselContainer = __webpack_require__(2471);
// EXTERNAL MODULE: ./components/services/Capabilities2.js
var Capabilities2 = __webpack_require__(7517);
// EXTERNAL MODULE: ./hooks/useScreenSize.js
var useScreenSize = __webpack_require__(5344);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./utils/industries.json
var industries_namespaceObject = JSON.parse('[{"slug":"banking","link":"industry/banking","title":"Banking & Fintech Technology Consulting | AI, Compliance, Payments | ITMTB","metaDesc":"ITMTB builds production systems for Indian banking and fintech — AI agents for fraud detection, RBI/SEBI-aligned compliance automation, and payment platform modernisation.","metaKeyword":"banking technology consulting India, AI for Indian banks, RBI compliance technology, fintech platform modernisation India, DPDP banking compliance, SEBI cybersecurity fintech, payment infrastructure India","image":"/services/industry/payments.webp","paragraph":"India\'s payment ecosystem will process over $10 trillion in digital transactions by 2026. The infrastructure supporting that volume faces simultaneous pressure on scale, fraud, and compliance. RBI Digital Lending Guidelines, SEBI cybersecurity circulars, and DPDP consent requirements are changing what banks and fintechs must build — not just what they should.<br/><br/><b>ITMTB builds and operates production systems for Indian banking and fintech — from tech stack audits for platforms processing millions of daily transactions to AI agents for fraud detection and compliance automation, aligned with RBI and SEBI requirements.</b>","heading":"Production Systems for Indian Banking and Fintech","mainHeading":"Banking and Payments","referTag":"Banking","clientNames":["Wright Research","Paterson Securities","Fonepay","The Business Research Company","GlobalFair"],"numbers":[{"number":"$10 trillion","detail":"India\'s digital payments market projected by 2026 — infrastructure at that scale demands reliability, not just speed."},{"number":"35%","detail":"of Indian users have experienced payment-related fraud, making AI-driven detection a compliance and commercial necessity."},{"number":"5%","detail":"average digital transaction failure rate (UPI) per RBI — a direct cost on every provider running legacy back-end systems."}],"points":[{"key":"AI Agents for Fraud and Risk Detection","title":"Real-time fraud detection and risk scoring — deployed as AI agents operating continuously on transaction streams.","text":"Rule-based fraud systems fail at scale because fraud patterns evolve faster than rules can be updated. AI agents monitor transaction streams in real time, scoring risk against behavioural baselines, flagging anomalies, and triggering automated holds or alerts — without requiring a human in the loop for every decision. For Indian fintechs operating under RBI\'s fraud reporting requirements, the speed of detection directly affects regulatory exposure."},{"key":"Compliance Automation — RBI, SEBI, DPDP","title":"Regulatory reporting and consent management built into the platform — not bolted on after audit.","text":"RBI Digital Lending Guidelines, SEBI cybersecurity circulars, and the DPDP Act each impose specific technical requirements: consent architecture, audit trails, data localisation, and breach notification timelines. We design compliance into the system architecture from the outset — not as a documentation exercise after the fact. The result is a platform that satisfies auditors and runs reliably in production."},{"key":"Payment Platform Modernisation","title":"Scalable, low-latency payment infrastructure — built to handle volume spikes without degradation.","text":"Most payment platform failures happen at two points: under load spikes (festive sales, salary cycles) and during migration from legacy systems. We architect payment platforms for horizontal scale, run load testing against production-representative traffic, and execute migrations from a tested runbook with defined rollback points. The 5% UPI failure rate is not an industry constant — it is a solvable engineering problem."},{"key":"Technical Due Diligence for Fintech Investment","title":"Independent technology assessments before acquisition, funding, or partnership commitments.","text":"Pre-investment and pre-acquisition technical audits for fintech platforms require a specific lens: what is the actual regulatory exposure, what is the technical debt load versus reported performance, and is the architecture capable of the scale the business model requires? We produce written assessments covering architecture, security posture, scalability limits, and a prioritised findings list with estimated remediation effort — deliverable in one to two weeks."}],"whyChooseUs":"We have audited tech stacks for Indian fintechs processing over one million transactions daily, built portfolio analytics platforms for capital markets firms serving a new generation of investors, and delivered transaction integrity systems for digital payment infrastructure. Engagements are designed for RBI Digital Lending Guidelines, SEBI cybersecurity circulars, and DPDP consent architecture from the outset."},{"slug":"insurance","link":"industry/insurance","title":"Insurance Technology Consulting | AI Underwriting, Claims Automation | ITMTB","metaDesc":"ITMTB builds AI underwriting support, claims automation, and cloud-native insurance infrastructure — designed for IRDAI compliance and IIB data reporting from the architecture phase.","metaKeyword":"insurance technology consulting India, AI underwriting India, IRDAI compliance technology, claims automation insurance India, InsurTech consulting India, IIB data reporting, core insurance system modernisation","image":"/services/industry/insurance.webp","paragraph":"India\'s insurance sector carries $127 billion in annual premiums and a 3.71% penetration rate — meaning most of the market remains unserved. IRDAI\'s digital transformation directives and IIB data reporting mandates are accelerating the shift to modern core systems. Claims still take weeks when they should take days. Underwriting decisions still rely on manual review when AI can improve speed and accuracy simultaneously.<br/><br/><b>ITMTB builds AI underwriting support, claims automation, and cloud-native insurance infrastructure — designed for IRDAI compliance and IIB data reporting requirements from the architecture phase, not as a retrofit.</b>","heading":"AI-Driven Insurance Systems, Built for IRDAI Compliance","mainHeading":"Insurance","referTag":"Insurance","clientNames":["The Business Research Company","Wright Research","Paterson Securities","GlobalFair","Fonepay"],"numbers":[{"number":"$127 billion","detail":"Total insurance premiums written in India — a market large enough to justify significant technology investment."},{"number":"10% CAGR","detail":"Consistent sector growth driven by rising awareness and digital adoption — compressing the window for modernisation."},{"number":"3.71%","detail":"Insurance penetration in India — the gap between current and potential represents the growth available to operators who modernise first."}],"points":[{"key":"AI Underwriting and Decision Support","title":"Automated data ingestion, risk scoring, and underwriting decision support — reducing turnaround from days to minutes.","text":"AI underwriting systems work by replacing the manual data-gathering phase: policy applications trigger automated retrieval of credit, claims history, and risk data, which feeds a scoring model that produces a recommended decision with confidence intervals. Underwriters review edge cases; routine applications are processed without human intervention. The architecture is the same whether the product is life, health, motor, or commercial — the models and data sources differ."},{"key":"Claims Automation","title":"Straight-through processing for routine claims — with AI triage routing complex claims to the right handler.","text":"Routine claims (minor motor, standard health, travel) can be processed end-to-end without human intervention when the supporting documents are available and the claim falls within expected parameters. AI triage classifies incoming claims by complexity, routes them to automated processing or human review, and flags potential fraud indicators before payout. The reduction in manual processing time directly reduces loss adjustment expenses."},{"key":"Cloud-Native Core Infrastructure","title":"Modern, scalable insurance platform architecture — replacing legacy systems without a big-bang cutover.","text":"Legacy insurance core systems fail in predictable ways: they cannot scale to handle digital distribution volumes, they cannot expose APIs for partner integration, and they accumulate compliance debt as regulations evolve. We modernise core systems using a strangler-fig approach — wrapping legacy systems with modern interfaces and migrating functionality progressively — so operations are not disrupted during the transition."},{"key":"IRDAI Compliance and IIB Data Reporting","title":"Compliance built into the architecture — not a documentation layer added before audit.","text":"IRDAI\'s digital transformation guidelines, IIB data reporting requirements, and insurance-specific data localisation rules each impose technical constraints on system design. We incorporate these constraints from the architecture phase: audit trails, consent management, data residency controls, and reporting interfaces are designed in, not bolted on. The result is a system that satisfies regulators without requiring manual reconciliation before each reporting cycle."}],"details2":{"title":"IoT and Telematics: The Next Data Layer","desc":"Connected vehicles, wearables, and smart home devices are generating the data that makes usage-based insurance viable at scale. We build the data pipelines that ingest telematics and IoT streams, normalise them into policy-relevant signals, and feed them into underwriting and pricing models — creating products that price risk accurately rather than by demographic proxy."},"whyChooseUs":"For a global intelligence and risk consulting firm, we deployed four production AI models — automating third-party risk reports, document analysis, and business intelligence workflows — with minimal human input. The same AI architecture applies directly to insurance underwriting automation and claims triage. We design for IRDAI compliance and IIB data reporting requirements from the start, not as an afterthought."},{"slug":"life-sciences","link":"industry/life-sciences","title":"Life Sciences Technology Consulting | Pharma, Biotech, Contract Manufacturing | ITMTB","metaDesc":"ITMTB builds compliant, production-grade platforms for pharma, biotech, and contract manufacturing — formulation management, supply chain systems, R&D data pipelines, CDSCO and FDA 21 CFR Part 11 aligned.","metaKeyword":"life sciences technology consulting India, pharma technology India, CDSCO compliance technology, FDA 21 CFR Part 11 cloud India, contract manufacturing platform India, biotech technology consulting India, AI drug discovery India","image":"/services/industry/lifescience.webp","paragraph":"India produces 20% of the world\'s generic medicines and is home to over 4,200 biotech startups — with a domestic pharma market on track for $130 billion by 2030. CDSCO compliance, FDA 21 CFR Part 11 requirements, and the operational complexity of contract manufacturing create technology problems that generic cloud platforms don\'t solve out of the box.<br/><br/><b>ITMTB builds compliant, production-grade platforms for pharma, biotech, and contract manufacturing — from formulation management and supply chain systems to R&D data pipelines and regulatory automation.</b>","heading":"Compliant Technology for Pharma and Contract Manufacturing","mainHeading":"Life Sciences","referTag":"Life Sciences","clientNames":["Wright Research","The Business Research Company","GlobalFair","C-DAC","Paterson Securities"],"numbers":[{"number":"$130 billion","detail":"Projected size of India\'s domestic pharmaceutical market by 2030 — growth that demands scalable technology infrastructure."},{"number":"20%","detail":"India\'s share of the global generic medicines supply — manufactured at scale, requiring production systems that are both efficient and audit-ready."},{"number":"18%","detail":"YoY export growth — pharma and biotech firms scaling exports face increasing pressure to meet global regulatory standards, not just domestic ones."},{"number":"4,200","detail":"Biotech startups expected to emerge in India — creating demand for R&D platforms that can move at startup speed while meeting enterprise compliance requirements."}],"points":[{"key":"Formulation and Contract Manufacturing Platforms","title":"Cloud-based formulation management and supply chain systems — built for the compliance and operational requirements of contract manufacturers.","text":"Contract manufacturing for pharma and FMCG requires managing formulations, raw material specifications, supplier qualifications, batch records, and quality holds — simultaneously, across multiple products and clients. We build the platform layer that replaces spreadsheets and email-based coordination with a structured, auditable system. FDA 21 CFR Part 11 electronic signature and audit trail requirements are designed in, not added later."},{"key":"AI-Assisted R&D and Drug Discovery","title":"AI and knowledge graphs applied to R&D data — accelerating discovery and reducing time-to-candidate.","text":"AI in R&D is most immediately valuable in the data-retrieval and pattern-matching phases of discovery: literature mining, structure-activity relationship analysis, and identifying candidate compounds from large chemical libraries. We build the data infrastructure and ML models that make these applications possible — connecting disparate data sources (internal assay results, public domain databases, regulatory submissions) into a queryable knowledge layer."},{"key":"Regulatory Compliance Automation","title":"CDSCO, FDA 21 CFR Part 11, and ICMR compliance built into the system — not managed through manual reconciliation.","text":"Regulatory compliance in life sciences is not a documentation problem — it is a data management problem. Audit trails, batch records, deviation reports, and change controls need to be captured at the point of action, not reconstructed before submission. We design systems that produce audit-ready records as a side effect of normal operations, reducing the manual effort before regulatory submissions to near zero."},{"key":"Clinical and Research Data Management","title":"Secure, structured data platforms for clinical trial data, research outcomes, and biobank management.","text":"Clinical trial data management requires systems that enforce protocol-defined data collection, maintain chain of custody for samples and records, and produce submissions in the format regulators accept. We build these systems with ICMR guidelines, ICH E6 Good Clinical Practice requirements, and DPDP-compliant data handling as design constraints — not as compliance checks after the platform is built."}],"details2":{"title":"Integration: Where Life Sciences Technology Stalls","subtitle":"Disconnected systems are the most common source of delay and cost in pharma operations.","desc":"Most life sciences technology failures are integration failures: ERP systems that cannot talk to manufacturing execution systems, LIMS that cannot feed data to regulatory submission tools, clinical data platforms that require manual export before analysis. We architect the integration layer as a first-class deliverable — not an afterthought — connecting the systems your teams use into workflows that run without manual intervention."},"relatedStory":{"prefix":"For a regulated pharma example, see our implementation story on","href":"/blog/pharma-compliance-ai-sop-bmr-warning-letter-review","label":"AI-assisted SOP, BMR, and warning-letter review","suffix":"with source evidence, reviewer control, and auditability designed into the workflow."},"whyChooseUs":"We built a cloud-based formulation and supply chain platform for a global contract manufacturer serving major consumer health and FMCG firms — delivering a 92% reduction in raw material selection errors and a 12% improvement in turnaround time within two months of go-live. Deployments are designed for CDSCO and FDA 21 CFR Part 11 compliance, with audit trail, electronic-signature, and validated cloud requirements built in from the outset."},{"slug":"retail","link":"industry/retail","title":"Retail Technology Consulting | D2C, Omnichannel, Last-Mile | ITMTB","metaDesc":"ITMTB builds retail technology for D2C storefronts, last-mile operations, and omnichannel platforms — cloud infrastructure, POS unification, AI personalisation, and supply chain integration.","metaKeyword":"retail technology consulting India, D2C platform India, omnichannel retail technology India, last-mile delivery technology India, AI retail personalisation India, retail supply chain India, ecommerce platform India","image":"/services/industry/retail.webp","paragraph":"India\'s retail sector is on course for $1.75 trillion by 2026. Only 11% of Indian retailers use AI and analytics; only 15% have unified customer data. The 30% who have modernised their tech stacks report measurably higher sales and lower inventory costs. D2C brands, quick-commerce operators, and omnichannel retailers are all solving the same problem: infrastructure that cannot keep up with the scale they are trying to reach.<br/><br/><b>ITMTB builds retail technology for D2C storefronts, last-mile operations, and omnichannel platforms — from cloud infrastructure and POS unification to AI-driven personalisation and supply chain integration.</b>","heading":"Retail Technology Built for Indian Scale","mainHeading":"Retail","referTag":"Retail","clientNames":["The Indian Garage Co.","GlobalFair","The Business Research Company","Wright Research","Fonepay"],"numbers":[{"number":"$1.75 trillion","detail":"Projected size of India\'s retail sector by 2026 — the technology gap between current and needed infrastructure is a direct cost on every operator."},{"number":"11%","detail":"Indian retailers currently using AI and analytics — the 89% who aren\'t are operating on instinct in a market where competitors have data advantages."},{"number":"15%","detail":"Retailers using unified customer data dashboards — without this, personalisation and demand forecasting are guesswork."},{"number":"30%","detail":"Retailers who modernised their tech stack reported higher sales, lower inventory costs, and improved supply chain performance — a consistent return on the investment."}],"points":[{"key":"D2C Storefront and Cloud Operations","title":"D2C platforms built to handle peak traffic without degradation — and operated continuously post-launch.","text":"D2C brands fail at two predictable points: during peak traffic events (launches, sales, festive season) when the infrastructure is not architected for scale, and in the months after launch when operational complexity outgrows what the founding team can manage manually. We architect cloud infrastructure for horizontal scale, load-test against production-representative traffic, and provide the operational support to keep the platform running reliably post-launch."},{"key":"Last-Mile Delivery Technology","title":"Dispatch systems, delivery tracking, and operational platforms built for the speed requirements of quick commerce.","text":"Ten-minute delivery is a technology problem as much as a logistics problem. The dispatch system needs to assign orders to the nearest available rider within seconds of order placement; the rider app needs to work reliably under variable connectivity; the operations platform needs to surface exceptions in real time. We build these systems — and we clear the technical debt in existing systems that is preventing delivery SLAs from being met."},{"key":"Omnichannel Commerce — POS, Inventory, CRM","title":"Unified commerce infrastructure connecting physical retail, ecommerce, and customer data into one operational view.","text":"Omnichannel retail fails when POS, ecommerce, and inventory systems operate as separate data silos — orders placed online aren\'t visible to store associates, inventory counts are unreliable, and customer history is fragmented across systems. We build the integration layer that connects these systems: a single inventory ledger, a unified customer profile, and a consistent order management flow regardless of how the purchase was initiated."},{"key":"AI Personalisation and Demand Forecasting","title":"Product recommendations, dynamic pricing, and demand forecasts driven by purchase behaviour — not demographic assumptions.","text":"Effective AI personalisation in retail requires three things: a unified customer data model, a recommendation model trained on actual purchase sequences, and a serving infrastructure that returns recommendations within the page load time budget. Demand forecasting requires the same data foundation plus promotional calendar and seasonal pattern integration. We build both — and we instrument them so the business can measure lift rather than relying on vendor claims."}],"whyChooseUs":"We rebuilt the digital storefront and cloud operations for a D2C apparel brand under a major Indian conglomerate, delivering capacity for 3× peak traffic four months post-launch. For a Series A hyperlocal grocery startup, we cleared the technical debt blocking 10-minute delivery SLAs. Both systems remain in production."},{"slug":"supply-chain","link":"industry/supply-chain","title":"Supply Chain Technology Consulting | AI, Logistics, ERP Integration | ITMTB","metaDesc":"ITMTB builds AI-driven supply chain systems for Indian and global operations — computer vision automation, ERP integration, multi-site inventory platforms, and predictive analytics.","metaKeyword":"supply chain technology consulting India, AI supply chain India, logistics technology India, Dynamics 365 supply chain India, supply chain visibility platform India, demand forecasting AI India, warehouse automation India","image":"/services/industry/supply chain.webp","paragraph":"Indian companies hold 30–45 days of inventory on average, against a global benchmark of 18 days. Logistics spend represents 14% of GDP, nearly double the global average. These are not inherent disadvantages — they are solvable engineering problems. The gap closes when the technology connecting demand signals, inventory positions, and fulfilment operations actually works.<br/><br/><b>ITMTB builds AI-driven supply chain systems for Indian and global operations — from computer vision automation and ERP integration to multi-site inventory platforms and predictive analytics.</b>","heading":"AI-Driven Supply Chain Systems for Indian and Global Operations","mainHeading":"Supply Chain","referTag":"Supply Chain","clientNames":["GlobalFair","The Indian Garage Co.","The Business Research Company","C-DAC","Wright Research"],"numbers":[{"number":"14%","detail":"Share of India\'s GDP spent on logistics — nearly double the global average of 8%, representing direct cost that technology can reduce."},{"number":"30–45 days","detail":"Average inventory held by Indian companies, versus a global benchmark of 18 days — the cash flow impact of this gap is calculable and closeable."},{"number":"20%","detail":"Indian supply chain organisations currently using advanced analytics for demand planning — the majority are still forecasting manually."},{"number":"11% CAGR","detail":"Projected growth of India\'s supply chain industry by 2030 — growth at this rate requires technology infrastructure that scales, not just headcount."}],"points":[{"key":"AI and Computer Vision Automation","title":"Custom AI models for pattern matching, quality inspection, and operational automation at supply chain scale.","text":"Manual processes in supply chain operations — product matching, quality inspection, document processing — are slow and do not scale. We build custom AI systems: convolutional neural networks for image-based matching and inspection, NLP models for document extraction, and ML models for anomaly detection in sensor and transaction data. These systems run in production, not in pilots — integrated into the operational workflow rather than operating as a separate analytics layer."},{"key":"ERP Integration — Dynamics 365, SAP, Odoo","title":"ERP systems connected to warehouse, logistics, and supplier data — so inventory and fulfilment run from a single source of truth.","text":"ERP implementations fail when the integration between the ERP and operational systems is treated as a secondary concern. We build the integration layer as a first-class deliverable: connecting warehouse management systems, carrier APIs, supplier portals, and IoT sensor streams to the ERP — so that inventory positions, order statuses, and supplier lead times are accurate without manual reconciliation. We have implemented Microsoft Dynamics 365 across multi-site logistics operations."},{"key":"Multi-Site Inventory Visibility","title":"Real-time inventory positions across warehouses, stores, and transit — available without manual reconciliation.","text":"The 30–45 day inventory holding pattern in Indian operations is partly a technology failure: when inventory positions across sites are not visible in real time, procurement teams over-order defensively, and operations teams cannot identify excess stock in one location that covers a shortage in another. We build the data platform that makes multi-site inventory visible in real time — integrated with demand forecasts to trigger replenishment automatically when positions fall below threshold."},{"key":"Demand Forecasting and Supply Planning","title":"ML-driven demand forecasts integrated with supply planning — reducing both stockouts and excess inventory simultaneously.","text":"Effective demand forecasting requires combining historical sales data, promotional calendars, seasonal patterns, and external signals (weather, events, economic indicators) into a model that produces SKU-level forecasts at the required planning horizon. We build these models, integrate them with the ERP supply planning module, and instrument them so forecast accuracy is measured and the model is retrained as demand patterns change."}],"whyChooseUs":"We built a custom convolutional neural network and serverless image-matching engine for a global supply chain leader managing 100,000+ SKUs across 35 countries — achieving 99% operational efficiency with sub-3-minute lookup times per item. We have also implemented Microsoft Dynamics 365 across multi-site logistics operations to unify inventory visibility and reduce manual reconciliation. Both systems remain in production."}]');
// EXTERNAL MODULE: ./components/reusable/FullScreenModal.js
var FullScreenModal = __webpack_require__(5833);
;// CONCATENATED MODULE: ./components/IndustryPage.js






var Navbar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2684), __webpack_require__.e(7804), __webpack_require__.e(1352)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});






var IndustryPage = function(_param) {
    var rest = _extends({}, _param);
    var size = (0,useScreenSize/* default */.Z)();
    var isSmall = size == "sm" || size == "md";
    var ref = (0,react.useState)(""), selectedItem = ref[0], setselectedItem = ref[1];
    var ref1 = (0,react.useState)({}), currentBlog = ref1[0], setcurrentBlog = ref1[1];
    var ref2 = (0,react.useState)({
        open: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    }), modalConfig = ref2[0], setmodalConfig = ref2[1];
    (0,react.useEffect)(function() {
        if (size && !isSmall) {
            setselectedItem("Banking and Payments");
        } else {
            setselectedItem("");
        }
    }, [
        size
    ]);
    (0,react.useEffect)(function() {
        var contentIdx = industries_namespaceObject.findIndex(function(item) {
            return item.mainHeading === selectedItem;
        });
        if (contentIdx != -1) {
            var selected = industries_namespaceObject[contentIdx];
            setcurrentBlog({
                title: selected.heading,
                subtitle: selected.paragraph,
                img: selected.image,
                category: selected.category,
                link: selected.link
            });
            if (isSmall) {
                setmodalConfig({
                    open: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2.CapabilityCard, {
                        title: selected.title,
                        subtitle: selected.paragraph,
                        knowMoreLink: selected.link,
                        hideTitle: true,
                        imgStyle: "rounded-[100%] h-[300px] w-[300px]"
                    })
                });
            }
        }
    }, [
        selectedItem,
        isSmall
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "bg-white",
        id: "Industry"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-screen bg-[#59aec3]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-[1600px] w-[90%] md:w-[85%] bg-[#59aec3] pt-[80px] md:pt-[150px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-4xl font-bold mb-4 text-white",
                            children: "Industries we serve"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[200px] h-[1px] bg-white mb-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between mt-2 w-[100%] ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[100%] md:w-[40%] text-black cursor-pointer pl-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: isSmall ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContainer/* default */.Z, {
                                                children: industries_namespaceObject.map(function(industry) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: " mb-6 py-4 px-4 w-[90%] mx-auto ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2.CapabilityCard2, {
                                                            title: "".concat(industry.mainHeading, " - \n ").concat(industry.heading),
                                                            subtitle: industry.paragraph,
                                                            img: industry.image,
                                                            imgStyle: " rounded-[100%] !h-[200px] !w-[200px]",
                                                            onHoverStart: function() {
                                                                return setselectedItem(industry.mainHeading);
                                                            },
                                                            activeItem: selectedItem,
                                                            isSmall: isSmall,
                                                            hideBtn: true
                                                        }, industry.title)
                                                    }, industry.title);
                                                })
                                            }) : industries_namespaceObject.map(function(industry) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2.CapabilityCard2, {
                                                    title: industry.mainHeading,
                                                    onHoverStart: function() {
                                                        return setselectedItem(industry.mainHeading);
                                                    },
                                                    activeItem: selectedItem,
                                                    isSmall: isSmall,
                                                    hideSubtitle: true,
                                                    styleClass: "mb-1 "
                                                }, industry.mainHeading);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden md:block md:w-[50%] whitespace-pre-line ",
                                        children: selectedItem && (currentBlog === null || currentBlog === void 0 ? void 0 : currentBlog.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2.CapabilityCard, {
                                            title: "".concat(currentBlog.title),
                                            subtitle: currentBlog.subtitle,
                                            img: currentBlog.img,
                                            knowMoreLink: currentBlog.link,
                                            styleClass: "mt-[-100px]",
                                            imgStyle: " rounded-[100%] !h-[260px] !w-[260px]",
                                            inactiveColor: "white"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenModal/* default */.Z, {
                isOpen: modalConfig.open,
                onClose: function() {
                    setmodalConfig(function() {
                        return {
                            open: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        };
                    });
                    setselectedItem("");
                },
                styleClass: "[&>div]:!bg-[#59aec3]",
                children: modalConfig.children
            })
        ]
    }));
};
/* harmony default export */ var components_IndustryPage = (IndustryPage);

// EXTERNAL MODULE: ./utils/data.js
var data = __webpack_require__(3449);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 145 modules
var motion = __webpack_require__(5791);
;// CONCATENATED MODULE: ./pages/capabilities.js




var capabilities_Navbar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2684), __webpack_require__.e(7804), __webpack_require__.e(1352)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});










var Capabilities = function() {
    var size = (0,useScreenSize/* default */.Z)();
    var isSmall = size == "sm" || size == "md";
    var ref = (0,react.useState)(""), selectedItem = ref[0], setselectedItem = ref[1];
    var ref1 = (0,react.useState)({}), currentBlog = ref1[0], setcurrentBlog = ref1[1];
    var ref2 = (0,react.useState)({
        open: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    }), modalConfig = ref2[0], setmodalConfig = ref2[1];
    var ref3 = (0,react.useState)([]), categories = ref3[0], setCategories = ref3[1];
    (0,react.useEffect)(function() {
        var uniqueCategories = (0,_to_consumable_array/* default */.Z)(new Set(capability_namespaceObject.map(function(item) {
            return item.category;
        })));
        setCategories(uniqueCategories);
        if (size) {
            setTimeout(function() {
                var hash = window.location.hash;
                var id = hash === null || hash === void 0 ? void 0 : hash.substring(1);
                var element = document.getElementById(id);
                if (id != "Industry") {
                    var scrollable = document.getElementById("scrollable");
                    if (element) {
                        var filteredCapability = capability_namespaceObject.filter(function(capability) {
                            return capability.category == id;
                        });
                        if (!isSmall) {
                            var ref;
                            setselectedItem(filteredCapability === null || filteredCapability === void 0 ? void 0 : (ref = filteredCapability[0]) === null || ref === void 0 ? void 0 : ref.title);
                        }
                        var rect = element.getBoundingClientRect();
                        var scrollTopPos = rect.top + window.scrollY;
                        var targetScrollTopPos = scrollTopPos - 200; // 200px above the element
                        scrollable.scrollTop = targetScrollTopPos;
                    // window.scrollTo({ top: targetScrollTopPos, behavior: "smooth" });
                    } else {
                        if (!isSmall) {
                            var ref1;
                            setselectedItem(capability_namespaceObject === null || capability_namespaceObject === void 0 ? void 0 : (ref1 = capability_namespaceObject[0]) === null || ref1 === void 0 ? void 0 : ref1.title);
                        }
                    }
                } else {
                    if (element) {
                        var filteredCapability1 = capability_namespaceObject.filter(function(capability) {
                            return capability.category == id;
                        });
                        if (!isSmall) {
                            var ref2;
                            setselectedItem(filteredCapability1 === null || filteredCapability1 === void 0 ? void 0 : (ref2 = filteredCapability1[0]) === null || ref2 === void 0 ? void 0 : ref2.title);
                        }
                        var rect1 = element.getBoundingClientRect();
                        var scrollTopPos1 = rect1.top + window.scrollY;
                        var targetScrollTopPos1 = scrollTopPos1 - 60;
                        window.scrollTo({
                            top: targetScrollTopPos1,
                            behavior: "smooth"
                        });
                    }
                }
            }, 500);
        }
    }, [
        size
    ]);
    (0,react.useEffect)(function() {
        var contentIdx = capability_namespaceObject.findIndex(function(item) {
            return item.title === selectedItem;
        });
        if (contentIdx != -1) {
            var selected = capability_namespaceObject[contentIdx];
            setcurrentBlog({
                title: selected.title,
                subtitle: selected.desc || selected.paragraph,
                img: selected.image,
                category: selected.category,
                link: selected.link
            });
            if (isSmall) {
                setmodalConfig({
                    open: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2.CapabilityCard, {
                        title: selected.title,
                        subtitle: selected.desc,
                        hideTitle: true,
                        knowMoreLink: selected.link,
                        imgStyle: " rounded-[100%] h-[300px] w-[300px]"
                    })
                });
            }
        }
    }, [
        selectedItem,
        isSmall
    ]);
    var sectionRef = (0,react.useRef)(null);
    var scrollToSection = function() {
        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(capabilities_Navbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-[#1B6B93]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto max-w-[1600px] w-[90%] md:w-[85%] bg-[#1B6B93] pt-[80px] pb-[30px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "w-fit text-4xl font-bold pb-4 text-white",
                                children: "Our Capabilities"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[200px] h-[1px] bg-white mb-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between mt-2 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "scrollable",
                                        className: "w-[100%] md:w-[40%] max-h-[70vh] overflow-y-auto no-scrollbar pl-4",
                                        children: categories.map(function(category) {
                                            var ref;
                                            var filteredCapability = capability_namespaceObject.filter(function(capability) {
                                                return capability.category == category;
                                            });
                                            var categoryDesc = data/* categoriesData */.zR === null || data/* categoriesData */.zR === void 0 ? void 0 : data/* categoriesData.filter */.zR.filter(function(categoryItem) {
                                                return categoryItem.title === category;
                                            });
                                            categoryDesc = categoryDesc === null || categoryDesc === void 0 ? void 0 : (ref = categoryDesc[0]) === null || ref === void 0 ? void 0 : ref["desc"];
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: category,
                                                className: " text-black cursor-pointer mb-20 ".concat(category == (categories === null || categories === void 0 ? void 0 : categories[categories.length - 1]) ? "mb-[50vh]" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mb-[20px] md:mb-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: " text-white text-4xl font-bold mb-2 ",
                                                                children: category
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-white/50 text-xl",
                                                                children: categoryDesc
                                                            })
                                                        ]
                                                    }),
                                                    isSmall ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContainer/* default */.Z, {
                                                        children: filteredCapability.map(function(capability) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: " mb-6 py-4 px-4 w-[90%] mx-auto ",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2.CapabilityCard2, {
                                                                    title: capability.title,
                                                                    img: capability.image,
                                                                    onHoverStart: function() {
                                                                        return setselectedItem(capability.title);
                                                                    },
                                                                    activeItem: selectedItem,
                                                                    isSmall: isSmall,
                                                                    imgStyle: "rounded-[100%] !h-[200px] !w-[200px]"
                                                                }, capability.title)
                                                            }, capability.key);
                                                        })
                                                    }) : filteredCapability.map(function(capability) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2.CapabilityCard2, {
                                                            title: capability.title,
                                                            onHoverStart: function() {
                                                                return setselectedItem(capability.title);
                                                            },
                                                            activeItem: selectedItem,
                                                            isSmall: isSmall,
                                                            hideSubtitle: true,
                                                            fadeTxtColor: "#ababab",
                                                            styleClass: "mb-1 !pl-0"
                                                        }, capability.title);
                                                    })
                                                ]
                                            }, category);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden md:block md:w-[50%] whitespace-pre-line ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: selectedItem && (currentBlog === null || currentBlog === void 0 ? void 0 : currentBlog.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2.CapabilityCard, {
                                                subtitle: currentBlog.subtitle,
                                                img: currentBlog.img,
                                                hideTitle: true,
                                                knowMoreLink: currentBlog.link,
                                                imgStyle: " rounded-[100%] !h-[260px] !w-[260px]"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb-[30px] mx-auto w-full flex flex-col items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-semibold text-2xl mb-4 text-white",
                                children: "Industries We Serve"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                onClick: scrollToSection,
                                className: "box",
                                variants: containerVariants,
                                initial: "initial",
                                animate: "animate",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    className: "rotate-90 cursor-pointer ",
                                    width: "40",
                                    height: "40",
                                    viewBox: "0 0 100 100",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                            cx: "50",
                                            cy: "50",
                                            r: "40",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            fill: "transparent"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M 50 30 L 70 50 L 50 70",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            fill: "transparent"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenModal/* default */.Z, {
                isOpen: modalConfig.open,
                onClose: function() {
                    setmodalConfig(function() {
                        return {
                            open: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        };
                    });
                    setselectedItem("");
                },
                styleClass: "[&>div]:!bg-[#1B6B93]",
                children: modalConfig.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: sectionRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IndustryPage, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
        ]
    });
};
/* harmony default export */ var capabilities = (Capabilities);
var containerVariants = {
    initial: {
        y: 0
    },
    animate: {
        y: [
            -5,
            0,
            -5
        ],
        transition: {
            y: {
                duration: 1,
                repeat: Infinity,
                ease: "easeInOut"
            }
        }
    }
};


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8418)


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,5791,8388,5290,7517,9774,2888,179], function() { return __webpack_exec__(3642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);